import React, { Component } from 'react'
import Included from '../Included'
class Carousel extends Component {

  constructor(props) {
    super(props)
  }

  render (){
    return(
    <section><a className="anchor"id="carousel"></a>
    <h2>Carousel</h2>
    { this.props.staticVersion === false ? (
      <Included
      onClick={() => this.props.onIncludeClick()}
      included={this.props.included}/>
    ) : ( '' ) }
    <br/>
    <p>Using the slick carousel <a href="http://kenwheeler.github.io/slick/">http://kenwheeler.github.io/slick/</a></p>
    <ul>
      <li>Fully responsive. Scales with its container.</li>
      <li>Separate settings per breakpoint</li>
      <li>Uses CSS3 when available. Fully functional when not.</li>
      <li>Swipe enabled. Or disabled, if you prefer.</li>
      <li>Desktop mouse dragging</li>
      <li>Infinite looping.</li>
      <li>Fully accessible with arrow key navigation</li>
      <li>Add, remove, filter & unfilter slides</li>
      <li>Autoplay, dots, arrows, callbacks, etc...</li>
  </ul>

    <div className="carousel js-carousel">
      <div className="carousel--panel"><img src="https://dummyimage.com/950x430/666666/ffffff&text=Slide+1"/></div>
      <div className="carousel--panel"><img src="https://dummyimage.com/950x430/666666/ffffff&text=Slide+2"/></div>
      <div className="carousel--panel"><img src="https://dummyimage.com/950x430/666666/ffffff&text=Slide+3"/></div>
      <div className="carousel--panel"><img src="https://dummyimage.com/950x430/666666/ffffff&text=Slide+4"/></div>
      <div className="carousel--panel"><img src="https://dummyimage.com/950x430/666666/ffffff&text=Slide+5"/></div>
      <div className="carousel--panel"><img src="https://dummyimage.com/950x430/666666/ffffff&text=Slide+6"/></div>
    </div>

    <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
    <pre className="hide-code"><code className="language-html">{`<div className="carousel js-carousel">
  <div className="carousel--panel"><img src="https://dummyimage.com/950x430/666666/ffffff&text=Slide+1"/></div>
  <div className="carousel--panel"><img src="https://dummyimage.com/950x430/666666/ffffff&text=Slide+2"/></div>
  <div className="carousel--panel"><img src="https://dummyimage.com/950x430/666666/ffffff&text=Slide+3"/></div>
  <div className="carousel--panel"><img src="https://dummyimage.com/950x430/666666/ffffff&text=Slide+4"/></div>
  <div className="carousel--panel"><img src="https://dummyimage.com/950x430/666666/ffffff&text=Slide+5"/></div>
  <div className="carousel--panel"><img src="https://dummyimage.com/950x430/666666/ffffff&text=Slide+6"/></div>
</div>`}</code></pre>
    <br/>
    <p>Initialise the carousel</p>
    <pre><code className="language-js" dangerouslySetInnerHTML={{__html: "$('.js-carousel').slick({dots: true, fade: true, cssEase: 'linear'});"}}></code></pre>
    <br/>
    <p>CSS Dependencies</p>
    <pre><code className="language-html">{`<link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.5.9/slick.min.css"/>
<link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.5.9/slick-theme.min.css"/>`}</code></pre>
    <br/>
    <p>JS Dependencies</p>
    <pre><code className="language-html">{`<script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.5.9/slick.min.js"></script>`}</code></pre>
    <br/>
    <hr/>
    </section>
  )
}
}

export default Carousel



// WEBPACK FOOTER //
// ./styleguide/components/sections/Carousel.js